import React from "react";
import { URL_CONSTANTS } from "../utils/constants";
import '../css/account-exists.css';

const AccountExistsComponent = () => {
  return (
    <div class="form-hero-section bg-lblack section-padding account-exists">
      <div class="form-container">
        <div class="form-hero-block">
          <div class="form-hero-content">
            <h2>
              Looks Like You Already Have an Apty Account
            </h2>
            <div>
              <p>You’ve already started your 15-day free trial of Apty’s Content Creation Studio </p>
            </div>
            <div class="site-text">
              <p>Log in to pick up where you left off and make the most of your trial period </p>
            </div>
          </div>
          <div class="form-hero-code">
            <div class="step-form-block">
              <div class="form-response">
                <div class="form-response-image">
                  <img src="https://www.apty.io/wp-content/uploads/2025/01/existing.svg" style={{maxWidth: '100%'}} alt=""/>
                    <div class="form-response-text">
                      <div class="fs-24 fw-500">Uh-oh! </div>
                      <div class="color-text">You Already Have an Apty Account</div>
                    </div>
                </div>
                <div class="form-footer mt-20 text-center">
                  <a href={URL_CONSTANTS.LOGIN} target="_blank" rel="noopener" class="form-btn">Login</a>
                  <div class="help-text">Please Check Your Inbox!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountExistsComponent;
